module.exports = __webpack_public_path__ + "img/6.ab7942c0.jpg";